/* CREATE TEST */
export const CREATE_TEST_REQUEST = "CREATE_TEST_REQUEST"
export const CREATE_TEST_SUCCESS = "CREATE_TEST_SUCCESS"
export const CREATE_TEST_FAIL = "CREATE_TEST_FAIL"

/* TEST DETAIL */
export const GET_TEST_DETAIL_REQUEST = "GET_TEST_DETAIL_REQUEST"
export const GET_TEST_DETAIL_SUCCESS = "GET_TEST_DETAIL_SUCCESS"
export const GET_TEST_DETAIL_FAIL = "GET_TEST_DETAIL_FAIL"

/* DELETE TEST */
export const DELETE_TEST_REQUEST = "DELETE_TEST_REQUEST"
export const DELETE_TEST_SUCCESS = "DELETE_TEST_SUCCESS"
export const DELETE_TEST_FAIL = "DELETE_TEST_FAIL"

 /* UPDATE TEST */
export const UPDATE_TEST_REQUEST = "UPDATE_TEST_REQUEST"    
export const UPDATE_TEST_SUCCESS = "UPDATE_TEST_SUCCESS"
export const UPDATE_TEST_FAIL = "UPDATE_TEST_FAIL"

    /* GET TESTS LIST */     
export const GET_TESTS_LIST_REQUEST = "GET_TESTS_LIST_REQUEST"
export const GET_TESTS_LIST_SUCCESS = "GET_TESTS_LIST_SUCCESS"
export const GET_TESTS_LIST_FAIL = "GET_TESTS_LIST_FAIL"